module.exports = __webpack_public_path__ + "img/check_new.8c4caa8b.svg";